import {emptyCounters,derivedMetrics,type MetricCounters} from '../../../../shared/report-metrics.ts';
type MetricRow={ [Key in keyof MetricCounters]?:number|null }&{metrics_state?:string};
/** Sum available observations without turning unknown rows into known zeros. */
export function calculateReportTotals(rows:MetricRow[]) {
  const counters=emptyCounters();let knownRows=0,unknownRows=0,partialRows=0;
  for(const row of rows) {
    if(row.metrics_state==='unknown'||row.spend==null||!Number.isFinite(Number(row.spend))){unknownRows++;continue;}
    knownRows++;if(row.metrics_state==='partial')partialRows++;
    for(const field of Object.keys(counters) as Array<keyof typeof counters>) {
      const value=Number(row[field]??0);if(Number.isFinite(value))counters[field]+=value;
    }
  }
  return {...counters,...derivedMetrics(counters,'report'),knownRows,unknownRows,partialRows,
    incomplete:unknownRows>0||partialRows>0,hasData:knownRows>0||rows.length===0};
}
